/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffEditPayrollAllowancesCtrl
 */
angular.module('mercury.modules.time.payroll.paytypes.allowance')
.controller('TimePayrollSpecialStaffEditorCtrl', function() {

});
